import { render, staticRenderFns } from "./CoLivingBenefits.vue?vue&type=template&id=43cf076c&"
import script from "./CoLivingBenefits.vue?vue&type=script&lang=js&"
export * from "./CoLivingBenefits.vue?vue&type=script&lang=js&"
import style0 from "./CoLivingBenefits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports